import React from 'react';

import { PropTypes } from 'helpers/react';
const { node, func, bool } = PropTypes;

import styles from './styles/index.scss';
import AppBar from 'shared-components/AppBar';

// instead of
// <Wizard>
//   { ({ currentPage, requestClose, renderStepper, renderButtons, renderConfirmationDialog }) => (
//     <div>
//       ... etc
//     </div>
//   ) }
// </Wizard>

// this wraps the dialog style of wizard so you can do
// <Wizard>
//   { popoverDialogWizardContainer({ title: 'Create New Engine' }) }
// </Wizard>

const popoverDialogWizardContainer = ({ title }) => {
  function PopoverDialogWizardContainer({
    currentPage,
    requestClose,
    renderStepper,
    renderButtons,
    renderConfirmationDialog,
    renderPreSubmitConfirmation,
    renderNoDefaultDagDialog,
    hideStepper,
  }) {
    return (
      <div style={{ height: '100%' }}>
        <AppBar title={title} centerTitle closeButton onClose={requestClose} />
        <div className={styles['container']}>
          {!hideStepper && (
            <div className={styles['stepperContainer']}>
              <div>{renderStepper()}</div>
            </div>
          )}

          <div className={styles['wizardPageContainer']}>{currentPage}</div>
        </div>
        <div className={styles['footer']}>
          {renderButtons({ className: styles['footer__button'] })}
        </div>
        {renderConfirmationDialog()}
        {renderPreSubmitConfirmation()}
        {renderNoDefaultDagDialog()}
      </div>
    );
  }

  PopoverDialogWizardContainer.propTypes = {
    currentPage: node,
    requestClose: func,
    renderStepper: func,
    renderButtons: func,
    renderConfirmationDialog: func,
    hideStepper: bool,
    renderPreSubmitConfirmation: func,
    renderNoDefaultDagDialog: func,
  };
  return PopoverDialogWizardContainer;
};

export default popoverDialogWizardContainer;



// WEBPACK FOOTER //
// ./src/client/shared-components/Wizard/PopoverDialogWizardContainer/index.js